import ConstructionIcon from '@mui/icons-material/Construction';
import FoundationIcon from '@mui/icons-material/Foundation';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import GrainIcon from '@mui/icons-material/Grain';
import GridViewIcon from '@mui/icons-material/GridView';
import BoltIcon from '@mui/icons-material/Bolt';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import FormatPaintIcon from '@mui/icons-material/FormatPaint';
import CarpenterIcon from '@mui/icons-material/Carpenter';
import AppsIcon from '@mui/icons-material/Apps';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import EngineeringIcon from '@mui/icons-material/Engineering';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import DescriptionIcon from '@mui/icons-material/Description';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

/* icon key (from expense_categories.icon) → MUI icon component */
const ICONS = {
  construction: ConstructionIcon,
  foundation: FoundationIcon,
  view_week: ViewWeekIcon,
  grain: GrainIcon,
  grid_view: GridViewIcon,
  bolt: BoltIcon,
  water_drop: WaterDropIcon,
  format_paint: FormatPaintIcon,
  carpenter: CarpenterIcon,
  apps: AppsIcon,
  local_shipping: LocalShippingIcon,
  agriculture: AgricultureIcon,
  engineering: EngineeringIcon,
  restaurant: RestaurantIcon,
  description: DescriptionIcon,
  receipt_long: ReceiptLongIcon,
};

const CategoryIcon = ({ icon, ...props }) => {
  const Icon = ICONS[icon] || ReceiptLongIcon;
  return <Icon {...props} />;
};

export default CategoryIcon;
